import script from "./EditProfessionalInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./EditProfessionalInformation.vue?vue&type=script&setup=true&lang=js"

import "./EditProfessionalInformation.vue?vue&type=style&index=0&id=1c603f23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c603f23"]])

export default __exports__